export default function getResource(label, vars = []) {
    const resources = {};

    return resources[label];
}
